module.exports = __webpack_public_path__ + "static/media/1.879d5eb0.svg";